import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
// import { MsalProvider } from '@azure/msal-react';
import { locale } from 'devextreme/localization';
locale('de-DE');

// Initialize MSAL instance
// const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {/* <MsalProvider instance={msalInstance}> */}
      <App />
    {/* </MsalProvider> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
